import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import auth0 from '../../helpers/auth0';
import postal from 'postal';

const channel = postal.channel('notification');

const isAuthenticated = (claim) => {
  if(!claim) return true;

  return auth0.hasClaim(claim);
};

const AuthRoute = ({component, claim, ...props}) => {
  if(!claim) {
    return <Route { ...props } component={ component } />;
  }

  const roleClaims = claim.split(',');
  if(roleClaims.some(isAuthenticated)) {
    return <Route { ...props } component={ component } />;
  }
  else {
    channel.publish('notification.add', {
      message: 'Ihnen fehlt die Berechtigung "' + claim + '"'
    });

    return <Redirect to="/" />;
  }
};

AuthRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func
  ])
};

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/components/common/AuthRoute.js